import { render, staticRenderFns } from "./processor.vue?vue&type=template&id=4f998e78&"
import script from "./processor.vue?vue&type=script&lang=js&"
export * from "./processor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports